import { defineStore } from 'pinia';
import { setAuthToken, axios } from '../axios';

export const useUserStore = defineStore('user', {
  state: () => ({
    token: localStorage.getItem('authToken') || null,
    userDetails: null,
    loadingUserDetails: false,
  }),

  getters: {
    isLoggedIn: (state) => !!state.token,
    isUserLoading: state => state.loadingUserDetails,
  },

  actions: {
    setToken(token) {
      this.token = token;
      if (token) {
        localStorage.setItem('authToken', token);
        setAuthToken(token);
      } else {
        localStorage.removeItem('authToken');
        setAuthToken(null);
      }
    },
    async login(email, password) {
      const { data } = await axios.post('login/', { email, password });
      this.setToken(data.key);
      await this.fetchUserDetails();
    },
    async fetchUserDetails() {
      this.loadingUserDetails = true;
      try {
        const { data } = await axios.get('userdetails/');
        this.userDetails = data;
      } catch (err) {
        console.error('Error al obtener los detalles del usuario:', err);
        this.userDetails = null;
      } finally {
        this.loadingUserDetails = false;
      }
    },
    async logout() {
      try {
        // Llamada al API para invalidar el token en el backend
        await axios.post('logout/');
      } catch (err) {
        console.warn('Error en API logout:', err);
        // puedes hacer algo con el error si lo deseas
      }
      // Limpio el estado local y el token
      this.setToken(null);
      this.userDetails = null;
    }
  },
});